import React from 'react'
import type { HeaderRowConfig } from '@ztechapps/webui.data-tools'
import { CheckboxHeaderCell, MenuHeaderCell } from '@ztechapps/webui.data-tools'
import { useProductListContext } from './Context'

export const ListHeader = (props: HeaderRowConfig) => {
  const { productListWithSelection } = useProductListContext()
  const { toggleSelectAll, hasSelectedAll } = productListWithSelection
  return (
    <>
      <MenuHeaderCell />

      <CheckboxHeaderCell onChange={toggleSelectAll} checked={hasSelectedAll} />

      {props._renderDataHeaderCell()}
    </>
  )
}
